export enum SubscriptionStatus {
  FreeTrial = 'free_trial',
  FreeTrialFinished = 'free_trial_finished',
  FreeTrialStop = 'free_trial_stop',
  Renew = 'renew',
  Active = 'active',
  Deactivated = 'deactivated',
  Closed = 'closed',
}
